import { render, staticRenderFns } from "./voice.vue?vue&type=template&id=aaba0b3e&scoped=true&"
import script from "./voice.vue?vue&type=script&lang=js&"
export * from "./voice.vue?vue&type=script&lang=js&"
import style0 from "./voice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./voice.vue?vue&type=style&index=1&id=aaba0b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaba0b3e",
  null
  
)

export default component.exports